import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { ProjectDiscussionMapComponent } from './components/project-discussion-map/project-discussion-map.component';

@NgModule({ declarations: [],
    exports: [
        ProjectDiscussionMapComponent,
    ], imports: [CommonModule,
        ProjectDiscussionMapComponent,
        GoogleMapsModule], 
    })
export class ProjectDiscussionMapModule { }
